import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { PanelFooter } from '../panel-footer/panel-footer';

const styles = cssMap({
	footerActionGroup: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: token('space.050'),
	},
});

export type PanelFooterSkeletonProps = {
	actionsCount: 1 | 2;
};

export function PanelFooterSkeleton({ actionsCount }: PanelFooterSkeletonProps): JSX.Element {
	const primaryActionSkeleton = (
		<Skeleton width="5rem" height="2rem" borderRadius={token('radius.medium')} />
	);
	const secondaryActionSkeleton =
		actionsCount === 2 ? (
			<Skeleton width={120} height="0.75rem" borderRadius={token('radius.full')} />
		) : null;

	return (
		<PanelFooter>
			<Box xcss={styles.footerActionGroup}>
				{secondaryActionSkeleton}
				{primaryActionSkeleton}
			</Box>
		</PanelFooter>
	);
}
